import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { AbsenceResource, absencesPost } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateAbsence = (
  publisherId: number | undefined,
  options: UseMutationOptions<
    AbsenceResource[],
    unknown,
    AbsenceResource,
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (absence) => {
      if (publisherId == null) {
        throw new Error('no publisher id given');
      }
      return extractData(
        absencesPost({ path: { publisherId }, body: absence })
      );
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['absences', publisherId] });
      options.onSuccess?.(...args);
    },
  });
};
